import React from "react";

class LoadingSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.overlay = React.createRef();
  }

  componentDidMount() {
    this.fadeInOutOverlay(this.props.show);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.fadeInOutOverlay(true);
    } else if (!this.props.show && prevProps.show) {
      this.fadeInOutOverlay(false);
    }
  }

  render() {
    var { style = {}, type = "" } = this.props;
    var defaultStyle = {
      display: "none",
      backgroundColor: this.props.backgroundColor || "auto",
    };
    var combinedStyle = { ...defaultStyle, ...style };
    return (
      <div
        className={
          "loadingOverlay " +
          (this.props.size == "small" ? "loadingOverlaySmall" : "")
        }
        ref={this.overlay}
        style={combinedStyle}
      >
        {type === "shimmer" ? (
          <div className="ui-shimmer-wrapper">
            <div className="ui-shimmer line" />
          </div>
        ) : (
          <div
            className={
              "spinner " + (this.props.size == "small" ? "spinner-sm" : "")
            }
          ></div>
        )}
      </div>
    );
  }

  fadeInOutOverlay(show) {
    if (show) {
      $(".modal-header").append($(".disableHeader"));
      $(".modal-footer").append($(".disableFooter"));
      $(".disableHeader").css("visibility", "visible");
      $(".disableFooter").css("visibility", "visible");
      $(this.overlay.current).fadeIn("fast");
    } else {
      $(".disableHeader").css("visibility", "hidden");
      $(".disableFooter").css("visibility", "hidden");
      $(this.overlay.current).fadeOut("fast");
    }
  }
}

export default LoadingSpinner;
